import React from 'react'
import { Link } from 'react-router-dom';

const FoamMattress = () => {
    return (
        <>
            <div className="product-section">
                <div className="container">
                    <div className="row">

                        {/* Product 1 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/coir5.jpg" className="img-fluid product-thumbnail" alt="ComfortLux Spring Mattress" />
                                <h3 className="product-title">Memory Foam Mattress</h3>
                                <strong className="product-price">₹ 10,500</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 2 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/mattress7.webp" className="img-fluid product-thumbnail" alt="AirFeel Spring Mattress" />
                                <h3 className="product-title">AirFeel Spring Mattress</h3>
                                <strong className="product-price">₹ 7,800</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 3 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/foam5.jpg" className="img-fluid product-thumbnail" alt="Propel Plus Spring Mattress" />
                                <h3 className="product-title">Propel Plus Spring Mattress</h3>
                                <strong className="product-price">₹ 14,430</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 4 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/coir2.jpg" className="img-fluid product-thumbnail" alt="SpringKoil Foam Mattress" />
                                <h3 className="product-title">SpringKoil Mattress</h3>
                                <strong className="product-price">₹ 11,200</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 5 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link className="product-item" to="#">
                                <img src="/images/mattress4.webp" className="img-fluid product-thumbnail" alt="PocketCoil Deluxe Mattress" />
                                <h3 className="product-title">PocketCoil Deluxe Mattress</h3>
                                <strong className="product-price">₹ 13,990</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 6 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link className="product-item" to="#">
                                <img src="/images/coir5.jpg" className="img-fluid product-thumbnail" alt="Orthopedic Spring Mattress" />
                                <h3 className="product-title">Orthopedic Spring Mattress</h3>
                                <strong className="product-price">₹ 12,000</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 7 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link className="product-item" to="#">
                                <img src="/images/coir2.jpg" className="img-fluid product-thumbnail" alt="ComfortPlus Spring Mattress" />
                                <h3 className="product-title">ComfortPlus Spring Mattress</h3>
                                <strong className="product-price">₹ 9,700</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 8 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link className="product-item" to="#">
                                <img src="/images/spring4.jpg" className="img-fluid product-thumbnail" alt="EcoSpring Lite Mattress" />
                                <h3 className="product-title">EcoSpring Lite Mattress</h3>
                                <strong className="product-price">₹ 8,450</strong>
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default FoamMattress;